module.exports = __webpack_public_path__ + "img/blanc.6626d4b5.png";